/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errorpanel_Troubleshoot_Step2title2Inputs */

const en_errorpanel_troubleshoot_step2title2 = /** @type {(inputs: Errorpanel_Troubleshoot_Step2title2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your connection`)
};

/**
* | output |
* | --- |
* | "Check your connection" |
*
* @param {Errorpanel_Troubleshoot_Step2title2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const errorpanel_troubleshoot_step2title2 = /** @type {((inputs?: Errorpanel_Troubleshoot_Step2title2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errorpanel_Troubleshoot_Step2title2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_errorpanel_troubleshoot_step2title2(inputs)
});
export { errorpanel_troubleshoot_step2title2 as "errorPanel_troubleshoot_step2Title" }